import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import changeAdminPassword from "../../services/changeAdminPassword";
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";

import getSetting from "../../services/getSetting";
import updateSetting from "../../services/updateSetting";
import Constants from "../../utils/consts";

import "moment/locale/it";
import { Checkbox } from "@material-ui/core";

export default class AdminSettings extends React.Component {
	constructor(props) {
		super(props);

		this.pageDiv = {
			border: "1px solid #cccccc",
			padding: 10,
		};

		this.section = this.props.section;
		if (this.section == undefined) {
			const pathname = props.location.pathname;
			this.section = pathname.substring(8, pathname.length);
		}

		this.pageTitle = props.pageTitle;
		this.pageName = props.pageName;
		if (this.pageName == undefined) {
			this.pageName = this.section;
		}

		this.userslist = [];

		this.state = {
			testo: "",
			menuBackground: "#ffffff",
			menuItemColor: "#000000",
			fontSize: 50,
			fontBold: false,
			logoPicture: "",
			logoMargin: 0,
			titleColor: "#000000",
			titleSize: 18,
			isLoading: false,
			addElementVisible: false,
			notifiche_lezioni: "1",
		};

		this.grid = 2;

		this.pageTitle = "Impostazioni";
	}

	async componentDidMount() {
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });

		this.mail = await getSetting(username, token, "sendingMailAddress");
		this.mailPassword = await getSetting(username, token, "sendingMailPassword");
		this.notifiche = await getSetting(username, token, "notificheLezioni");

		this.setState({
			mail: this.mail,
			mailPassword: this.mailPassword,
			oldPassword: "",
			newPassword: "",
			confirm: "",
			notifiche_lezioni: this.notifiche,
		});
	}

	render() {
		function createData(username, name, surname) {
			return { username, name, surname };
		}

		var rows = [];
		this.userslist.length > 0 &&
			this.userslist.map((v, k) => {
				rows.push(createData(v.username, v.name, v.surname));
			});

		return (
			<>
				<LoadingOverlay
					active={this.state.isLoading}
					styles={{
						content: base => ({
							position: "relative",
							width: "100%",
							top: "200px",
						}),
					}}
					spinner
					text={"Loading your content..."}
				>
					<PageTitle title={this.pageTitle} />

					<h3>Modifica password</h3>
					<TextInput
						name={"Vecchia Password "}
						type={"password"}
						value={this.state.oldPassword}
						onChange={text => {
							this.setState({ oldPassword: text });
						}}
					/>
					<TextInput
						name={"Nuova Password "}
						type={"password"}
						value={this.state.newPassword}
						onChange={text => {
							this.setState({ newPassword: text });
						}}
					/>
					<TextInput
						name={"Conferma nuova Password"}
						type={"password"}
						value={this.state.confirm}
						onChange={text => {
							this.setState({ confirm: text });
						}}
					/>

					<div style={{ marginBottom: 10, marginTop: 10 }}>APIS PATH: {Constants.mainUrl}</div>

					<FixButton
						title={"Save"}
						callback={async () => {
							const cookies = new Cookies();
							const username = cookies.get("username", { path: "/" });
							const token = cookies.get("token", { path: "/" });

							var changed = false;
							if (this.mail != this.state.mail) {
								await updateSetting(username, token, "sendingMailAddress", this.state.mail);
								changed = true;
							}
							if (this.mailPassword != this.state.mailPassword) {
								await updateSetting(username, token, "sendingMailPassword", this.state.mailPassword);
								changed = true;
							}

							if (changed) {
								this.mail = this.state.mail;
								this.mailPassword = this.state.mailPassword;
								alert("Aggiornamento riuscito");
							}

							if (this.state.oldPassword == "") return;
							if (this.state.newPassword == "") return;
							if (this.state.confirm == "") return;
							if (this.state.newPassword != this.state.confirm) {
								alert("The password confirm is not valid");
								return;
							}

							let ret = await changeAdminPassword(
								username,
								token,
								this.state.oldPassword,
								this.state.newPassword
							);
							if (ret.success == false) {
								alert("Error changing password. Please check your data");
							} else {
								alert("Password changed successfully");
								this.setState({
									oldPassword: "",
									newPassword: "",
									confirm: "",
								});
							}
						}}
					/>
				</LoadingOverlay>
			</>
		);
	}
}
